import React from 'react';
import { FaVideo } from 'react-icons/fa';

import { Container } from './styles';

interface IVideoProps {
  iconSize?: number;
}

const Video: React.FC<IVideoProps> = ({ iconSize }) => {
  return (
    <Container>
      <FaVideo size={iconSize !== undefined ? iconSize : 50} />
    </Container>
  );
};

export default Video;
